module.exports = __webpack_public_path__ + "img/kelev_bachatzer_yes.a1b2f5cf.png";